<template>
  <div id="app">
    <!-- 头和底公用 -->
    <v-header />
    <div class="router-view-container" :class="{ 'router-login-view': showbg }">
      <!-- 侧边栏除登录注册外显示，根据路由中的showLeftMenu判断是否显示 -->
      <!-- 头部 我的 X-lab 随着侧边菜单栏那一起显示与隐藏 -->
      <v-user-bar v-if="showLeftMenu" />
      <div class="view-main" :class="{ nmb: showbg }">
        <div class="view-main-container">
          <router-view />
        </div>
      </div>
    </div>

    <v-footer />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {},
  methods: {},
  computed: {
    showLeftMenu() {
      return this.$store.state.showLeftMenu;
    },
    showbg() {
      return this.$store.state.showbg;
    },
  },

  mounted() {},
};
</script>

<style lang='less'>
@import "./assets/style/common.less";
@media screen and (max-width: 1000px) {
    .el-message-box{
  width: auto!important;
}
  @import "./assets/style/mobileCommon.less";
}
.sl1{
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.wxtx{
  background-color: rgba(255,0,0,0.6);
  color: #fff;
  padding: 15px;
  font-weight: bold;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue